/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import * as configure from "./configure";

export type Int64 = string | number;

export enum BannerState {
  No = 0,
  Online = 1,
  Offline = 2,
}

export enum EventType {
  abandon_task = 1,
  postponed_task = 2,
}

export enum GroupType {
  Default = 0,
  Board = 1,
  Special = 2,
}

export enum PostReplyFeedBackStatus {
  SHOW_FEEL_GOOD = 1,
  NOT_SHOW_FEEL_GOOD = 2,
}

export enum ProjectMode {
  label = 1,
  audit = 2,
  double_review = 3,
  sample_audit = 4,
  custom = 5,
  full_custom = 6,
}

export enum TaskMode {
  label = 1,
  audit = 2,
  double_review = 3,
}

export interface AbandonTaskEventInfo {
  abandon_by_username?: string;
  submit_time?: string;
}

export interface Banner {
  Id: string;
  Image: string;
  Url: string;
  State: BannerState;
  Serial: number;
  Label: string;
  Operator: string;
  CreatedAt: string;
  UpdatedAt: string;
  Title: string;
}

export interface CasePost {
  Id: string;
  User?: User;
  Type: string;
  TypeName: string;
  Scope: string;
  ScopeName: string;
  Title: string;
  FeedbackType: number;
  FeedbackTypeName: string;
  FeedbackState: number;
  FeedbackStateName: string;
  Comments: Array<string>;
  Email: string;
  ResolvingTime: Int64;
  Uid: Int64;
  Url: string;
  Biz?: configure.Biz;
  collected: number;
}

export interface Comment {
  Id: string;
  Visible: boolean;
  Delete: boolean;
  PostId: string;
  UserId: string;
  UserInfo: User;
  Html: string;
  Text: string;
  CreatedAt: string;
  UpdatedAt: string;
  TcsUrl: string;
  CreatedAtInt64: Int64;
  UpdatedAtInt64: Int64;
  IsLiked?: boolean;
  Liked?: number;
  Replied?: number;
}

export interface CreateCommentRequest {
  PostId: string;
  Html: string;
  Uid: Int64;
  Biz?: configure.Biz;
  Uris?: Array<string>;
}

export interface CreateCommentResponse {
  error: number;
  message?: string;
  data?: CreateCommentResponseData;
}

export interface CreateCommentResponseData {
  CommentId: string;
  CostTime: number;
}

export interface CreatePostRequest {
  Uid: Int64;
  Title: string;
  Html: string;
  Scope: string;
  Type: string;
  Meta: Record<string, string>;
  Biz?: configure.Biz;
  BizList?: Array<configure.Biz>;
  Uris?: Array<string>
}

export interface CreatePostResponse {
  error: number;
  message?: string;
  data?: CreatePostResponseData;
}

export interface CreatePostResponseData {
  PostId: string;
  CostTime: number;
}

export interface CreateReplyRequest {
  CommentId: string;
  Html: string;
  ToUserId: string;
  Uid: Int64;
  Biz?: configure.Biz;
}

export interface CreateReplyResponse {
  error: number;
  message?: string;
  data?: CreateReplyResponseData;
}

export interface CreateReplyResponseData {
  ReplyId: string;
  CostTime: number;
}

export interface DeleteCommentRequest {
  CommentId: string;
  Reason: string;
  Uid: Int64;
  Biz?: configure.Biz;
}

export interface DeleteCommentResponse {
  error: number;
  message?: string;
  data?: DeleteCommentResponseData;
}

export interface DeleteCommentResponseData {
  CostTime: number;
}

export interface DeleteGroupRequest {
  Uid: Int64;
  GroupId: string;
  Biz?: configure.Biz;
}

export interface DeleteGroupResponse {
  error: number;
  message?: string;
  data?: DeleteGroupResponseData;
}

export interface DeleteGroupResponseData {}

export interface DeletePostGroupRequest {
  Uid: Int64;
  GroupId: string;
  PostId: string;
  Biz?: configure.Biz;
}

export interface DeletePostGroupResponse {
  error: number;
  message?: string;
  data?: DeletePostGroupResponseData;
}

export interface DeletePostGroupResponseData {}

export interface DeleteReplyRequest {
  ReplyId: string;
  Reason: string;
  Uid: Int64;
  Biz?: configure.Biz;
}

export interface DeleteReplyResponse {
  error: number;
  message?: string;
  data?: DeleteReplyResponseData;
}

export interface DeleteReplyResponseData {
  CostTime: number;
}

export interface EsSearchRequest {
  Query: string;
  Scope: string;
  Limit: number;
  Offset: number;
}

export interface EsSearchResponse {
  error: number;
  message?: string;
  data?: EsSearchResponseData;
}

export interface EsSearchResponseData {
  TotalNum: number;
  MiniAppNum: number;
  MiniGameNum: number;
  MerchantNum: number;
  OtherNum: number;
  List: Array<Post>;
}

export interface FeedbackBindPostRequest {
  FeedbackId?: Int64;
}

export interface FeedbackBindPostResponse {
  error: number;
  message?: string;
  data?: FeedbackBindPostResponseData;
}

export interface FeedbackBindPostResponseData {}

export interface FeedbackHookRequest {
  RawData: string;
}

export interface FeedbackHookResponse {
  error: number;
  message?: string;
  data?: FeedbackHookResponseData;
}

export interface FeedbackHookResponseData {}

export interface GetBannersRequest {
  Scope?: string;
}

export interface GetBannersResponse {
  error: number;
  message?: string;
  data?: GetBannersResponseData;
}

export interface GetBannersResponseData {
  Banners: Array<Banner>;
}

export interface GetCasePostRequest {
  PostId: string;
}

export interface GetCasePostResponse {
  error: number;
  message?: string;
  data?: GetCasePostResponseData;
}

export interface GetCasePostResponseData {
  Post?: CasePost;
}

export interface GetCommentListRequest {
  Condition?: Params;
  PageNum: number;
  PageSize: number;
  PostId: string;
}

export interface GetCommentListResponse {
  error: number;
  message?: string;
  data?: GetCommentListResponseData;
}

export interface GetCommentListResponseData {
  CommentList?: Array<Comment>;
  TotalNum?: number;
  CostTime: number;
}

export interface GetPostListByUidRequest {
  UserId?: string;
  Uid?: Int64;
  PageNum: number;
  PageSize: number;
  FromUserId?: string;
  FromUid?: Int64;
  FromBiz?: configure.Biz;
  Biz?: configure.Biz;
}

export interface GetPostListByUidResponse {
  error: number;
  message?: string;
  data?: GetPostListByUidResponseData;
}

export interface GetPostListByUidResponseData {
  PostList?: Array<Post>;
  TotalNum: number;
}

export interface GetPostReplyFeedbackStatusRequest {
  PostId: string;
  Uid: Int64;
  Biz?: configure.Biz;
}

export interface GetPostReplyFeedbackStatusResponse {
  error: number;
  message?: string;
  data?: GetPostReplyFeedbackStatusResponseData;
}

export interface GetPostReplyFeedbackStatusResponseData {
  status: PostReplyFeedBackStatus;
}

export interface GetPostRequest {
  PostId?: string;
  Uid?: Int64;
  Biz?: configure.Biz;
}

export interface GetPostResponse {
  error: number;
  message?: string;
  data?: GetPostResponseData;
}

export interface GetPostResponseData {
  PostInfo: Post;
  CostTime: number;
}

export interface GetPostsByGroupIdRequest {
  GroupId: string;
  Type?: string;
  PageNo?: number;
  PageSize?: number;
}

export interface GetPostsByGroupIdResponse {
  error: number;
  message?: string;
  data?: GetPostsByGroupIdResponseData;
}

export interface GetPostsByGroupIdResponseData {
  GroupInfo: Group;
  PageNo: number;
  PageSize: number;
  TotalNum: number;
  CostTime: number;
}

export interface GetPostsByGroupRequest {
  Scope: string;
}

export interface GetPostsByGroupResponse {
  error: number;
  message?: string;
  data?: GetPostsByGroupResponseData;
}

export interface GetPostsByGroupResponseData {
  List: Array<Group>;
  CostTime: number;
}

export interface GetPostsFromPostIdRequest {
  Uid: Int64;
  Scope: string;
  Type: string;
  Choice: string;
  PostId?: string;
  Biz?: configure.Biz;
  PostCount?: number;
}

export interface GetPostsFromPostIdResponse {
  error: number;
  message?: string;
  data?: GetPostsFromPostIdResponseData;
}

export interface GetPostsFromPostIdResponseData {
  List: Array<Post>;
  CostTime: number;
}

export interface GetPostsRequest {
  Uid: Int64;
  Scope: string;
  Type: string;
  PageNo: number;
  PageSize: number;
  Choice?: string;
  Biz?: configure.Biz;
}

export interface GetPostsResponse {
  error: number;
  message?: string;
  data?: GetPostsResponseData;
}

export interface GetPostsResponseData {
  List: Array<Post>;
  TotalNum: number;
  PageNo: number;
  PageSize: number;
  CostTime: number;
}

export interface GetPostsToConsoleRequest {
  Uid?: Int64;
  Biz?: configure.Biz;
  PostCount: Int64;
}

export interface GetPostsToConsoleResponse {
  error: number;
  message?: string;
  data?: GetPostsToConsoleResponseData;
}

export interface GetPostsToConsoleResponseData {
  List: Array<Post>;
  TotalNum: number;
  CostTime: number;
}

export interface GetReplyListRequest {
  Condition?: Params;
  PageNum: number;
  PageSize: number;
  CommentIds: Array<string>;
}

export interface GetReplyListResponse {
  error: number;
  message?: string;
  data?: GetReplyListResponseData;
}

export interface GetReplyListResponseData {
  ReplyList?: Array<Reply>;
  TotalNum?: number;
  CostTime: number;
}

export interface GetSummaryRequest {}

export interface GetSummaryResponse {
  error: number;
  message?: string;
  data?: GetSummaryResponseData;
}

export interface GetSummaryResponseData {
  summary: string;
}

export interface Group {
  Id: string;
  Name: string;
  Scope: string;
  Remark: string;
  CreatedAt: string;
  UpdatedAt: string;
  UserId: string;
  PostList: Array<Post>;
  GroupType: GroupType;
}

export interface InsertGroupRequest {
  Uid: Int64;
  Scope: string;
  Name: string;
  GroupType: GroupType;
  Biz?: configure.Biz;
}

export interface InsertGroupResponse {
  error: number;
  message?: string;
  data?: InsertGroupResponseData;
}

export interface InsertGroupResponseData {
  GroupId: string;
}

export interface InsertPostGroupRequest {
  Uid: Int64;
  GroupId: string;
  PostId: string;
  Biz?: configure.Biz;
  Index?: number;
}

export interface InsertPostGroupResponse {
  error: number;
  message?: string;
  data?: InsertPostGroupResponseData;
}

export interface InsertPostGroupResponseData {}

export interface InsertTicketRequest {
  PostId: string;
}

export interface InsertTicketResponse {
  error: number;
  message?: string;
  data?: InsertTicketResponseData;
}

export interface InsertTicketResponseData {
  TicketId: Int64;
}

export interface MGetObjectDataReq {
  object_ids?: Array<string>;
  project_meta?: ProjectMeta;
  request_type?: number;
}

export interface MGetObjectDataRsp {
  error: number;
  message?: string;
  data?: MGetObjectDataRspData;
}

export interface MGetObjectDataRspData {
  object_data_map: Record<string, string>;
}

export interface MSetTaskResultReq {
  project_meta?: ProjectMeta;
  task_results?: Array<TaskResult>;
  config?: string;
  rule?: string;
  dry_run?: Int64;
}

export interface MSetTaskResultRsp {
  error: number;
  message?: string;
  data?: MSetTaskResultRspData;
}

export interface MSetTaskResultRspData {
  failed_task_ids?: Array<Int64>;
  node_results?: Array<NodeResult>;
}

export interface NexusRequest {
  Ticket: Ticket;
}

export interface NexusResponse {
  error: number;
  message?: string;
  data?: NexusResponseData;
}

export interface NexusResponseData {}

export interface NodeResult {
  status_code?: number;
  status_message?: string;
  node_context?: string;
  node_name?: string;
  node_type?: string;
}

export interface NotifyTaskEventReq {
  project_meta?: ProjectMeta;
  task_events?: Array<TaskEvent>;
}

export interface NotifyTaskEventRsp {
  error: number;
  message?: string;
  data?: NotifyTaskEventRspData;
}

export interface NotifyTaskEventRspData {
  failed_task_ids?: Array<Int64>;
}

export interface Params {
  Delete?: boolean;
  Visible?: boolean;
  Uid?: Int64;
  ToUid?: Int64;
  CreatedAtInt64?: Int64;
  UpdatedAtInt64?: Int64;
  Biz?: configure.Biz;
  ToBiz?: configure.Biz;
}

export interface Post {
  Id: string;
  Visible: boolean;
  Delete: boolean;
  IsTop: boolean;
  IsGood: boolean;
  ViewCount: number;
  CommentCount: number;
  Scope: string;
  Type: string;
  UserId: string;
  UserInfo?: User;
  Title: string;
  Html: string;
  Text: string;
  Meta: Record<string, string>;
  CreatedAt: string;
  UpdatedAt: string;
  TcsUrl: string;
  FeedbackUrl: string;
  SearchHighlightInfo?: SearchHighlight;
  Liked?: number;
  PostLiked?: number;
  IsLiked?: boolean;
  Collected?: number;
}

export interface PostReplyFeedback {
  Score: number;
  Content: string;
}

export interface ProjectMeta {
  project_id?: Int64;
  product_type?: string;
  project_group?: string;
  project_slug?: string;
  project_mode?: ProjectMode;
  task_mode?: TaskMode;
  project_title?: string;
  tags?: Array<string>;
  project_type?: number;
  extra?: string;
}

export interface RemovePostRequest {
  Uid: Int64;
  PostId: string;
  Reason?: string;
  Biz?: configure.Biz;
}

export interface RemovePostResponse {
  error: number;
  message?: string;
  data?: RemovePostResponseData;
}

export interface RemovePostResponseData {}

export interface Reply {
  Id: string;
  PostId: string;
  CommentId: string;
  Visible: boolean;
  Delete: boolean;
  UserId: string;
  UserInfo: User;
  ToUserId: string;
  ToUserInfo: User;
  Html: string;
  Text: string;
  CreatedAt: string;
  UpdatedAt: string;
  TcsUrl: string;
  CreatedAtInt64: Int64;
  UpdatedAtInt64: Int64;
  IsLiked?: boolean;
  Liked?: number;
}

export interface SearchHighlight {
  Highlight?: Record<string, Array<string>>;
}

export interface SelfVisibleCommentRequest {
  CommentId: string;
  Visible: boolean;
  Uid: Int64;
  Reason: string;
  Biz?: configure.Biz;
}

export interface SelfVisibleCommentResponse {
  error: number;
  message?: string;
  data?: SelfVisibleCommentResponseData;
}

export interface SelfVisibleCommentResponseData {
  CostTime: number;
}

export interface SelfVisiblePostRequest {
  Uid: Int64;
  PostId: string;
  Reason?: string;
  Biz?: configure.Biz;
}

export interface SelfVisiblePostResponse {
  error: number;
  message?: string;
  data?: SelfVisiblePostResponseData;
}

export interface SelfVisiblePostResponseData {
  CostTime: number;
}

export interface SelfVisibleReplyRequest {
  ReplyId: string;
  Visible: boolean;
  Uid: Int64;
  Reason: string;
  Biz?: configure.Biz;
}

export interface SelfVisibleReplyResponse {
  error: number;
  message?: string;
  data?: SelfVisibleReplyResponseData;
}

export interface SelfVisibleReplyResponseData {
  CostTime: number;
}

export interface SetFbTypeIdRequest {
  Id?: string;
  Num?: Int64;
}

export interface SetFbTypeIdResponse {
  error: number;
  message?: string;
  data?: SetFbTypeIdResponseData;
}

export interface SetFbTypeIdResponseData {}

export interface SubmitPostReplyFeedbackRequest {
  PostId: string;
  Uid: Int64;
  Feedback: PostReplyFeedback;
  Biz?: configure.Biz;
}

export interface SubmitPostReplyFeedbackResponse {
  error: number;
  message?: string;
  data?: SubmitPostReplyFeedbackResponseData;
}

export interface SubmitPostReplyFeedbackResponseData {}

export interface TaskEvent {
  task_id?: Int64;
  object_id?: string;
  object_version?: number;
  event_type?: EventType;
  abandon_task_event_info?: AbandonTaskEventInfo;
  extra?: Record<string, string>;
}

export interface TaskResult {
  task_id?: Int64;
  object_id?: string;
  object_version?: number;
  merged_result?: VerifyResult;
  verify_results?: Array<VerifyResult>;
  current_turn?: number;
  object_data?: string;
  task_mode?: TaskMode;
  has_next_turn?: number;
}

export interface Ticket {
  Id: string;
  CreatedAt: Int64;
  UpdatedAt: Int64;
  Status: string;
  PostId: string;
  TicketId: Int64;
  OpenChatId: string;
  LarkChatId: string;
  Submitter: string;
  Owner: string;
  Operator: string;
}

export interface ToggleCollectPostRequest {
  Uid?: Int64;
  Biz?: configure.Biz;
  PostId?: string;
}

export interface ToggleCollectPostResponse {
  error: number;
  message?: string;
  data?: ToggleCollectPostResponseData;
}

export interface ToggleCollectPostResponseData {}

export interface ToggleCommentDeleteRequest {
  CommentId: string;
  Reason: string;
  Uid: Int64;
  Biz?: configure.Biz;
}

export interface ToggleCommentDeleteResponse {
  error: number;
  message?: string;
  data?: ToggleCommentDeleteResponseData;
}

export interface ToggleCommentDeleteResponseData {
  CostTime: number;
}

export interface ToggleCommentVisibleRequest {
  CommentId: string;
  Uid: Int64;
  Reason: string;
  Biz?: configure.Biz;
}

export interface ToggleCommentVisibleResponse {
  error: number;
  message?: string;
  data?: ToggleCommentVisibleResponseData;
}

export interface ToggleCommentVisibleResponseData {
  CostTime: number;
}

export interface ToggleGoodRequest {
  PostId: string;
  Uid: Int64;
  Biz?: configure.Biz;
}

export interface ToggleGoodResponse {
  error: number;
  message?: string;
  data?: ToggleGoodResponseData;
}

export interface ToggleGoodResponseData {
  IsGood: boolean;
}

export interface ToggleLikeRequest {
  Uid?: Int64;
  Type?: string;
  TypeId?: string;
  Biz?: configure.Biz;
}

export interface ToggleLikeResponse {
  error: number;
  message?: string;
  data?: ToggleLikeResponseData;
}

export interface ToggleLikeResponseData {}

export interface ToggleReplyVisibleRequest {
  ReplyId: string;
  Uid: Int64;
  Reason: string;
  Biz?: configure.Biz;
}

export interface ToggleReplyVisibleResponse {
  error: number;
  message?: string;
  data?: ToggleReplyVisibleResponseData;
}

export interface ToggleReplyVisibleResponseData {
  CostTime: number;
}

export interface ToggleTopRequest {
  PostId: string;
  Uid: Int64;
  Biz?: configure.Biz;
}

export interface ToggleTopResponse {
  error: number;
  message?: string;
  data?: ToggleTopResponseData;
}

export interface ToggleTopResponseData {
  IsTop: boolean;
}

export interface UpdatePostRequest {
  Uid: Int64;
  PostId: string;
  Title?: string;
  Html?: string;
  Biz?: configure.Biz;
  Uris?: Array<string>
}

export interface UpdatePostResponse {
  error: number;
  message?: string;
  data?: UpdatePostResponseData;
}

export interface UpdatePostResponseData {}

export interface User {
  Id: string;
  Name: string;
  Role: string;
  Mobile: string;
  Avatar: string;
}

export interface VerifyResult {
  verify_id?: Int64;
  verify_result?: string;
  verifier?: string;
  turn?: number;
  assign_time?: Int64;
  resolve_time?: Int64;
}

export interface VisiblePostRequest {
  Uid: Int64;
  PostId: string;
  Reason?: string;
  Biz?: configure.Biz;
}

export interface VisiblePostResponse {
  error: number;
  message?: string;
  data?: VisiblePostResponseData;
}

export interface VisiblePostResponseData {}
/* eslint-enable */
